import { render } from "./ChangeItemOrderDialog.vue?vue&type=template&id=7edff5e3&scoped=true"
import script from "./ChangeItemOrderDialog.vue?vue&type=script&lang=js"
export * from "./ChangeItemOrderDialog.vue?vue&type=script&lang=js"

import "./ChangeItemOrderDialog.vue?vue&type=style&index=0&id=7edff5e3&scoped=true&lang=css"

import exportComponent from "/Users/francois/WebstormProjects/crema-manager-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7edff5e3"]])

export default __exports__